// base
import styled from 'styled-components';
// styles
import { themeOptions } from 'styles';
// consts
import { commonImage } from 'constants';

export const StyledBasicButton = styled.div`
  .MuiButtonBase-root {
    width: ${(props) => (props.width ? props.width : 'auto')};
    height: 40px;
    box-shadow: none;
    border-radius: 6px;
    /* border: 1px solid ${themeOptions.palette.green.main}; */
    box-shadow: 0px 4px 19px 0px rgba(0, 0, 0, 0.1);

    &:hover {
      box-shadow: 0px 4px 19px 0px #0000001a;
    }

    &.modalCloseButton {
      background-image: url(${commonImage.modalClose});
      background-size: contain;
      background-repeat: no-repeat;
      transform: translateY(8px);
      margin-left: auto;
      width: 24px !important;
      border: none !important;
      box-shadow: none !important;
      min-width: 24px !important;
    }

    &.iconButton {
      padding: 0;
      width: 24px !important;
      min-width: 24px !important;
      border: none !important;
      box-shadow: none !important;
    }
  }

  .MuiButton-text {
    color: ${themeOptions.palette.green.main};
  }

  .MuiButton-contained {
    background: ${({ bgColor }) =>
      bgColor ? bgColor : themeOptions.palette.green.main} !important;
  }

  .MuiButton-outlined {
    border: 1px solid ${themeOptions.palette.green.main};
    background: ${themeOptions.palette.white.main} !important;
    color: ${themeOptions.palette.green.main};
  }
`;
